import React, { createContext, useContext, useState } from "react";

const SiteContext = createContext();

export const SiteProvider = ({ children }) => {
  const [selectedSite, setSelectedSite] = useState("");

  return (
    <SiteContext.Provider value={{ selectedSite, setSelectedSite }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => {
  const context = useContext(SiteContext);
  if (!context) {
    throw new Error("useSite must be used within a SiteProvider");
  }
  return context;
};

